import React from 'react';
import Reveal from '../Reveal';
import Timeline from '../Timeline';

const ROLES = [
    {
        title: "Software Engineer Co-op/Intern",
        badge: "RBC",
        logoSrc: "/logos/rbc.webp",
        logoSlug: null,
        org: "RBC (Royal Bank of Canada)",
        location: "Toronto, ON",
        period: "Sept 2026 - Present",
        status: null,
        tech: ["REST APIs", "AI Governance", "HITL Orchestration", "Protobuf"],
        bullets: [
            "Scaling enterprise financial services to support millions of concurrent requests at 99.9% availability by engineering resilient REST APIs and secure internal data pipelines.",
            "Improving metadata reliability across systems serving millions of customer accounts by engineering scalable services for data discovery, validation, and governance.",
            "Strengthening AI governance and execution safety across enterprise LLM workflows by implementing HITL orchestration that routes sensitive actions through specialized sub-agents and approval checkpoints.",
            "Improving reliability and security across distributed financial services by enforcing Protobuf contracts, validation guardrails, and controlled agent boundaries for enterprise data transmission.",
        ],
        accent: 'spark',
    },
    {
        title: "Software Engineer Co-op/Intern",
        badge: "N",
        logoSrc: "/logos/nokia.png",
        logoSlug: "nokia",
        org: "Nokia, AI Infrastructure",
        location: "Ottawa, ON",
        period: "Jan 2026 - Aug 2026",
        status: null,
        tech: ["Kubernetes", "OpenTelemetry", "ArgoCD", "vLLM", "MCP"],
        bullets: [
            "Recovered 80% memory headroom on a production-critical service by root-causing recurring out-of-memory (OOM) pod restarts and rebalancing Kubernetes scheduling.",
            "Built an OpenTelemetry observability layer tracing per-agent latency, token usage, context utilization, and memory footprint, establishing performance baselines across automated workflows.",
            "Compressed deployment time from 30 to 5 minutes across 10 microservices and 2 clusters with a GitOps pipeline reconciling Ansible-provisioned bare-metal nodes via ArgoCD.",
            "Provisioned a self-hosted vLLM inference backbone on load-balanced Kubernetes serving 1,000 users, cutting GPU spend 35% and egress 80% by caching model weights.",
            "Eliminated 95% of manual test creation and cut false positives 40% with a multi-agent testing pipeline wired into CI/CD for continuous network validation.",
            "Accelerated network configuration 70% with a gateway MCP server routing agents across sub-MCP clusters to automate certificate issuance, security validation, and config generation.",
        ],
        accent: 'signal',
    },
];

const Experience = () => {
    return (
        <section id="experience" className="py-20 px-4 md:px-0 max-w-6xl mx-auto">
            <Reveal className="space-y-2 mb-12">
                <p className="text-spark font-mono text-sm">{'// section.experience'}</p>
                <h2 className="font-display text-4xl font-bold text-foreground">Work <span className="text-spark text-glow-spark">Experience</span></h2>
            </Reveal>

            <Timeline items={ROLES} />
        </section>
    );
};

export default Experience;
